import { SET_EVENT_VIEW, SET_EVENT_CATEGORY, SET_EVENT_DATE } from '../actions/setFilters'

import moment from 'moment'

const initialState = {
  view: 'monthly',
  category: '',
  date: moment(new Date())
}

export default function filtersData(state = initialState, action) {
  switch (action.type) {
    case SET_EVENT_VIEW:
      return {
        ...state,
        view: action.payload
      }
    case SET_EVENT_CATEGORY:
      return {
        ...state,
        category: action.payload
      }
    case SET_EVENT_DATE:
      return {
        ...state,
        date: action.payload
      }

    default:
      return state
  }
}
